import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { Unit } from 'src/features/units/utils/types';
import { UnitFormSchemaValues } from 'src/features/units/utils/formSchema';

const RESOURCE = '/financial-documents/unit/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: UnitFormSchemaValues): Promise<Unit> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateUnit };
